import { render, staticRenderFns } from "./Availables.vue?vue&type=template&id=37c98122"
import script from "./Availables.vue?vue&type=script&lang=js"
export * from "./Availables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports